import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/apps/$appId/users')({
  component: UsersLayout,
})

function UsersLayout() {
  return <Outlet />
}
